import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Typography } from "@mui/material";
import Bottom from "../Bottom";
import Top from "../Top";
import Circle from "../../components/CircleProgress";
import BarChart from "../../components/BarChart";
import HistoryObjective from "../../components/HistoryObjective";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import schedule from "../../assets/icon/schedule.gif";
import * as util from "../../utils/util";
import api from "../../utils/api";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import HistorySliderInput from "../../components/HistorySliderInput";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetStep = {
  step: 0,
  target_step: 0
}

const HistoryWalking = () => {
  const [targetDate, setTargetDate] = React.useState('');
  const [targetStep, setTargetStep] = React.useState(initTargetStep);
  const [series, setSeries] = React.useState([
    { dataKey: 'step', label: '걸음수', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
  ]);
  const [dataset, setDataset] = React.useState([{ target: 0, step: 0, month: '' }]);
  const [dayValue, setDayValue] = useState(0);


  useEffect(() => {
    setStepData();
  }, [dayValue]);

  function setStepData() {
    // 걸음수 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_005?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetDate(params.target);
        setTargetStep(res.data.result_data.target);
        setSeries(series);
        let tempArr = [];
        for (let item of res.data.result_data.data.step_v2) {
          let obj = { target: 0, step: 0, month: '' };
          obj.month = item.date;
          obj.step = item.step;
          tempArr.push(obj);
        }
        setDataset(tempArr.reverse());
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 목표 걸음수 저장
  function saveTargetStep(value: any) {
    const saveParams = { date: '', targetStep: '' };
    saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
    saveParams.targetStep = value;

    api.post(`app/api/v1/AP_002_012`, saveParams).then(res => {
      setStepData();
    }).catch(function (error) {
      console.log(error)
    });
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="걸음 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid sx={{
              '& .CircleChart .MuiGauge-root': { width: '130px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
              '& .MuiGauge-valueArc': {
                fill: '#e029ff !important',
              },
            }}>
              <Circle progress={{ goal: targetStep.target_step, value: targetStep.step }} />
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={schedule} sx={{ m: 'auto', width: '60px', height: '60px' }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 35, color: '#e029ff', fontWeight: 700 }}>
                  {targetStep.step}
                </Typography>
                <Typography component="span" sx={{ fontSize: 20, color: '#999', mb: 0, textAlign: 'right' }}>
                  {targetStep.target_step}
                </Typography>
              </Stack>

              <Typography component="div" sx={{ fontSize: 18, color: '#777', ml: 1, mb: 2 }}>
                Step
              </Typography>
            </Stack>
          </Stack>

          <Grid container justifyContent="center" alignItems="center" >
            <HistorySliderInput info={{ value: targetStep.target_step, title: '목표 걸음수를 입력하세요', unit: 'step', btnTitle: '목표 설정', max: 20000 }} handleComplete={saveTargetStep} />
          </Grid>

          <Box sx={{ bgcolor: '#fff', p: '0 10px 10px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2  }} >
                <Button  sx={{fontSize:12, color:'#555', }} endIcon={<ArrowRightIcon />} >
                월간현황
              </Button>
              </Stack>
            </Stack>
            <Divider />
            <Box sx={{
              mt: -3.5,
              '& .MuiBarElement-root': { fill: '#e029ff' },
              '& .MuiChartsLegend-mark': { fill: '#e029ff' }
            }}>
              <BarChart dataset={dataset}
                chartSetting={chartSet}
                series={series}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '47%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const chartSet = {
  xAxis: [
    {
      label: '',
    },
  ],
  maxWidth: 450,
  height: 300,
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -5,
      itemMarkWidth: 10,
      itemMarkHeight: 10,
      labelStyle: {
        fontSize: 12,
      },
    },
  },
};

export default HistoryWalking;